








import Vue from 'vue';
import { DefaultData, DefaultMethods, DefaultComputed, DefaultProps } from 'vue/types/options.d';

export default Vue.extend<DefaultData<Vue>, DefaultMethods<Vue>, DefaultComputed, DefaultProps>({
  name: 'lableList',
  components: {},
  data() {
    return {};
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    labelsHeight: {
      type: String,
      default: ''
    }
  },
  watch: {
    list: {
      immediate: true,
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.$emit('update:labelsHeight', (this.$el as HTMLElement).offsetHeight);
        });
      }
    }
  },

  methods: {
    onSelect(val: string) {
      this.$emit('onSelect', val);
    }
  }
});
